export default __webpack_public_path__ + "static/media/grant.37ab8a6f.wav";